<template>
  <div class="code-content">
    <div class="code-item" v-for="(item, index) in num" :key="item" :class="{'blink': index === setValue.length, 'active': index < setValue.length}">
      <div class="val" ref="ref"></div>
    </div>
    <input class="code-input" type="text" :value="value" @input="input" @keyup.delete="deletePwd" ref="input" :disabled="isable">
  </div>
</template>

<script type="text/javascript">
export default {
  props: {
    num: {
      type: Number,
      default: 4
    },
    url: {
      type: String
    },
    type: {
      type: String,
      default: 'number'
    }
  },
  data() {
    return {
      currentNum: 1,
      value: '',
      allowDel: true,
      isable: false,
      setValue: []
    }
  },
  mounted() {
    this.initTep()
  },
  methods: {
    initTep() {
      this.$nextTick(() => {
        this.$refs.input.focus()
        this.$refs.input.setAttribute('type', this.type)
      })
    },
    input(e) {
      this.value = e.target.value
      let text = this.value
      this.setValue.push(text)
      let regExp = /^[0-9]+?$/
      if (this.type === 'password') {
        regExp = /^[a-zA-Z]{1}$/
      }
      // if (this.value !== '' && regExp.test(text)) {
      //   this.$refs.ref[this.currentNum - 1].innerHTML = text
      //   this.currentNum++
      //   this.value = ''
      // } else {
      //   e.target.value = ''
      //   this.value = ''
      // }
      if (this.value !== '' && regExp.test(text)) {
        const textArr = text.toString().split('')
        if (textArr.length > this.num) {
          textArr.length = this.num
        }
        const self = this
        textArr.forEach(item => {
          self.$refs.ref[self.currentNum - 1].innerHTML = item
          self.currentNum++
        })
      }
      e.target.value = ''
      this.value = ''
      if (this.currentNum > this.num) {
        this.isable = true
        this.currentNum = this.num
        this.allowDel = false
        let code = ''
        for (let i = 0; i < this.num; i++) {
          code += this.$refs.ref[i].innerHTML
        }
        this.$emit('fillCb', code)
        this.$emit('input', e)
      }
    },
    deletePwd () {
      this.setValue.pop()
      if (this.allowDel) {
        this.currentNum = this.currentNum <= 1 ? 1 : this.currentNum - 1
        this.$refs.ref[this.currentNum - 1].innerHTML = ''
      }
    },
    clear () {
      this.currentNum = 1
      this.allowDel = true
      this.isable = false
      this.setValue = []
      for (let i = 0; i < this.num; i++) {
        this.$refs.ref[i].innerHTML = ''
      }
      this.initTep()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "common-css/func.scss";
@import "common-css/mixins.scss";
.verify-code {
  width: 100%;
  position: relative;
  display: flex;
  overflow: hidden;
  margin: 0 auto;
}
.code-content {
  display:flex;
  transform: translateZ(0);
  margin-top: px2rem(10);
  .code-item {
    position: relative;
    flex: 1;
    width: 13%;
    padding-top: px2rem(94);
    margin-left: 3%;
    border: 1px solid #CCC;
    border-radius: px2rem(4);
    &.active {
      border: 1px solid#4A4C5B;
    }
    &:first-child {
      margin-left: 0
    }
    &.blink {
      border: 1px solid#4A4C5B;
      &:before {
        content: ' ';
        position: absolute;
        left: 50%;
        top: 50%;
        height: 50%;
        transform: translateY(-50%);
        width: 1px;
        animation: infinite linear 1.6s blink;
      }
    }
    .val {
      position: absolute;
      left: 0;
      right: 0;
      top: 40%;
      transform: translateY(-40%);
      bottom: 0;
      font-size: px2rem(50);
      color: #333;
      line-height: 1;
      text-align: center;
    }
  }
  .code-input {
    position: absolute;
    top: 0;
    left: 0;
    width: 200%;
    height: px2rem(94);
    border: 1px solid #000;
    margin-left: px2rem(-50);
    opacity: 0;
  }
}
@keyframes blink {
  0% {
    background: #f3f4f5;
  }
  30% {
    background: #4A4C5B;
  }
  70% {
    background: #4A4C5B;
  }
  100% {
    background: #f3f4f5;
  }
}
</style>
